import { Loading, Message } from 'element-ui'
import axios from 'axios'
import store from '../store/storeAll'
import toolFunction from "@/utils/toolFunction";
axios.defaults.timeout = 60000 // 超时时间
let fullLoading
function replaceStartProxy(url) {
  let _url = url
  if (_url.startsWith('/')) {
    _url = _url.slice(1, _url.length)
  }
  const index = _url.indexOf('/')
  const PROXY_CONFIG_STR = sessionStorage['PROXY_URL_CONFIG']
  const PROXY_CONFIG = PROXY_CONFIG_STR ? JSON.parse(PROXY_CONFIG_STR) : {}
  if (index !== -1 && PROXY_CONFIG_STR && !_url.startsWith('http')) {
    // 说明存在斜杠
    const start = _url.slice(0, index)
    if (PROXY_CONFIG && PROXY_CONFIG[start]) {
      _url = PROXY_CONFIG[start] + _url.slice(index)
    }
  }
  return _url
}
function showLoading() {
  fullLoading = Loading.service({
    lock: true,
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: '#eceaea12'
  })
  setTimeout(_ => {
    fullLoading.close()
  }, 10000)
}
function closeLoading() {
  fullLoading && fullLoading.close()
}
let loading_request_count = 0
function show_full_screen_loading() {
  if (loading_request_count === 0) {
    showLoading()
  }
  loading_request_count++
}
function hide_full_screen_loading() {
  if (loading_request_count <= 0) return
  loading_request_count--
  if (loading_request_count === 0) {
    closeLoading()
  }
}

axios.interceptors.request.use(
  config => {
    config.headers['_version'] = '2.1.8.2023.11.30'
    const params=config.params||{}
    config.headers['Authorization'] =params.token|| sessionStorage['token']
    // 删除此token
    delete params.token
    config.url = replaceStartProxy(config.url)
    if (config.url.indexOf('no_loading') === -1 && !config.url.startsWith('http:') && !config.url.startsWith('https:')) {
      config.url = config.url.replace('//', '/')
      show_full_screen_loading()
    }
    return config
  },
  err => {
    hide_full_screen_loading()
    return Promise.reject(err)
  }
)
function response_success_del(response) {
  const { url, method, data } = response.config
  const debug_sql = response.headers.debug_sql
  const { status, statusText } = response
  let responseText = ''
  try {
    responseText =
      typeof response.request.response === 'object'
        ? ''
        : response.request.responseText
  } catch (e) {
    responseText = ''
  }
  if (debug_sql) {
    const debug_sql_c = decodeURIComponent(debug_sql)
      .replace(/\*{3}/g, '\n')
      .replace(/\|{5}/g, '\n\n')
    store.commit('set_dug_sql_error_info', {
      url,
      debug_sql: debug_sql_c,
      status,
      statusText,
      method,
      responseText,
      data
    })
  }
}
function handle200Error(response) {
  const { data, config } = response
  if (data && typeof data === 'object') {
    const { code, message, status, success } = data
    if (status === 401) {
      Message.error(message || 'token已经过期,5秒后将重新跳转登录!')
      setTimeout(() => {
        toolFunction.oidcLoginOut()
      }, 5000)
      throw new Error(message)
    }
    let error_title = ''
    let error_detail = ''
    if (success === false || (status && +status !== 200)) {
      error_title = message
      error_detail = code + ': ' + config.url
      store.commit('set_error_info', { error_title, error_detail })
      throw new Error(message)
    }
  }
}
function handleErrorInfo(error) {
  const { response, message, status, config } = error
  let error_title = ''
  let error_detail = ''
  if (response) {
    const { statusText, data, status } = response
    if (status === 504) {
      error_title = '请求超时504'
      error_detail = data
    } else if (status === 404) {
      error_title = '404资源请求路径找不到'
      error_detail = config.url
    } else if (data && typeof data == 'object' && ('error_title' in data && 'error_detail' in data)) {
      error_title = data.error_title || '服务器异常,点击下面按钮查看详情'
      error_detail = data.error_detail
    } else if (data && typeof data == 'object' && !('error_title' in data) && ('message' in data) && ('status' in data)) {
      error_title = data.message || data.status
      error_detail = config.url
    } else {
      error_title = message || status
      error_detail = statusText + ':  ' + config.url
    }
  } else {
    error_title = message || status
    error_detail = status + ':  ' + config.url
  }
  store.commit('set_error_info', { error_title, error_detail })
}
// 增加一个response拦截器
axios.interceptors.response.use(
  function (response) {
    hide_full_screen_loading()

    response_success_del(response)
    handle200Error(response)
    return response
  },
  async (error) => {

    hide_full_screen_loading()
    const { response, config } = error
    const responseStatus = response && response.status
    const responseData = (response && response.data) || {}
    // export_type===expired 才是token失效 要从新刷新token
    if (responseStatus === 401 && (responseData.error_type === 'expired' || responseData.error_type === undefined)) {
      //return tokenTool.hand401MeaageWebframe(error.response.config)
      await toolFunction.hsConfirm('token已经过期,请点击确定,重新登录!')
      toolFunction.oidcLogin()
    } else {
      if (!config.url.includes('noErrorHint')) {
        // 当问号参数中有noErrorHint参数时不会出现错误提示
        handleErrorInfo(error)
      }
      return Promise.reject(error)
    }
  }
)
export default axios


// WEBPACK FOOTER //
// ./src/http/interceptors.js